// extracted by mini-css-extract-plugin
export default {"container":"container_PaoPI","title":"title_ZCnfw","list":"list_to041","item":"item_NmmbP","isSmall":"isSmall_w8CCw"};